import {
  axiosInstance,
  axiosLegacy,
  axiosROW,
  axiosPayment,
  axiosAccess,
} from "@config/axiosConfig";
import axios from "axios";

export const getAccessLegacyDetails = async (payload: any) => {
  return await axiosLegacy.get(`/${payload}`);
};

export const getRowLegacyDetails = async (payload: any) => {
  return await axiosROW.get(`/legacy-row-details/${payload}`);
};

export const updateAcessLegacyDetails = async (payload: any) => {
  return await axiosLegacy.put(`/update`, payload);
};

export const getFinalAccessLegacyDetails = async (payload: any) => {
  return await axiosLegacy.get(`/final/${payload}`);
};

export const updateFinalAcessLegacyDetails = async (payload: any) => {
  return await axiosLegacy.put(`/final/update`, payload);
};

export const updateRowLegacyDetails = async (payload: any) => {
  return await axiosROW.post(`/update-old-row`, payload);
};

export const submitAccessLegacyDetails = async (payload: any) => {
  return axiosLegacy.put("/submit", payload);
};

export const submitFinalAccessLegacyDetails = async (payload: any) => {
  return axiosLegacy.put("/final/submit", payload);
};

export const submitRowLegacyDetails = async (payload: any) => {
  return axiosROW.put(`/update-legacy-application/${payload}`);
};


export const authorityList = async () => {
  return axiosLegacy.get("/authorities");
}

export const roListSelection = async (id: any) => {
  return axiosLegacy.get(`/authorities/ro/${id}`);
} 


export const piuListSelection = async (id: any) => {
  return axiosLegacy.get(`/authorities/pa/${id}`);
} 


export const getAuthorityListAPI = async () => {
  return await axiosLegacy.get("/authorities");
};

export const getROList = async (payload: any) => {
  return await axiosLegacy.get(`/authorities/ro/${payload}`);
};

export const getPAList = async (payload: any) => {
  return await axiosLegacy.get(`/authorities/pa/${payload}`);
};

export const getLegacyTransactionDetails = async (legacyApplicationId: any) => {
  return await axiosPayment.get(
    `/legacy-transaction-detail?legacyApplicationId=${legacyApplicationId}`
  );
};

export const updateLegacyPaymentDetails = async (payload: any) => {
 return  await axiosROW.put("/update-payment-details", payload); 
};

export const getLegacySubStages = async () => {
  return await axiosLegacy.get("/sub-stages");
};
